export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_03.92bc6398.jpg";